import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Mail, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true); setError("");
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (err) {
      setError(err?.response?.data?.detail || "Couldn't send reset email. Try again.");
    } finally { setSubmitting(false); }
  };

  return (
    <div className="pgm-login-bg">
      <div className="pgm-reveal" style={{ width: "100%", maxWidth: 460 }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 18 }}>
          <div style={{ width: 56, height: 56, background: "var(--pgm-magenta)", display: "flex", alignItems: "center", justifyContent: "center", border: "1.5px solid var(--pgm-wine)" }}>
            <Mail size={26} color="var(--pgm-cream)" />
          </div>
        </div>
        <div className="pgm-card">
          <div className="pgm-micro">◆ Account recovery</div>
          <h2 className="pgm-display" style={{ fontSize: 28, marginBottom: 14 }}>Forgot your password?</h2>

          {sent ? (
            <div data-testid="forgot-sent">
              <div className="pgm-callout" style={{ background: "var(--pgm-olive)", color: "var(--pgm-cream)" }}>
                <strong>Check your inbox.</strong> If an account exists for <em>{email}</em>, we just sent a reset link. It expires in 1 hour.
              </div>
              <Link to="/login" className="pgm-link" style={{ display: "inline-flex", alignItems: "center", gap: 6, marginTop: 14 }}>
                <ArrowLeft size={14} /> Back to sign in
              </Link>
            </div>
          ) : (
            <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
              <p style={{ fontSize: 13, color: "var(--pgm-wine)", opacity: 0.8, marginTop: 0 }}>
                Enter the email on your account and we'll send you a link to set a new password.
              </p>
              <div>
                <label className="pgm-label">Email</label>
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="pgm-input" required autoFocus data-testid="forgot-email" />
              </div>
              {error && <div className="pgm-callout" style={{ background: "var(--pgm-orange)", color: "var(--pgm-cream)" }} data-testid="forgot-error">{error}</div>}
              <button className="pgm-btn" type="submit" disabled={submitting} data-testid="forgot-submit">{submitting ? "Sending..." : "Send reset link"}</button>
              <Link to="/login" className="pgm-link" style={{ display: "inline-flex", alignItems: "center", gap: 6 }} data-testid="forgot-back-login">
                <ArrowLeft size={14} /> Back to sign in
              </Link>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
